import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class RateLimitError extends EluveError {
  static override readonly errorName = 'RateLimitError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Rate limit exceeded', args?: EluveErrorArgs) {
    super(message, args);
  }
}
